<template>
  <el-select
    v-model="v"
    filterable
    remote
    reserve-keyword
    placeholder="введите ИНН"
    :remote-method="remoteMethod"
    :loading="search_inn"
    :popper-class="'inn-select'"
  >
    <el-option
      v-for="item in companyes_search"
      :key="item.data.inn"
      :label="item.label"
      :value="item.data.inn"
    >
      <div class="company-select" @click="selected = item.data">
        <div class="compyny-seelct__name">
          {{ item.data.name.short_with_opf }}
        </div>
        <div class="compyny-seelct__info">
          ИНН: {{ item.data.inn }}; КПП: {{ item.data.kpp }};
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import axios from "axios";

export default {
  props: ["value"],
  name: "INN",
  data: function () {
    return {
      v: "",
      search_inn: false,
      companyes_search: [],
      selected: {},
    };
  },
  watch: {
    v: function (value) {
      this.$emit("input", value);
      this.$emit("update:data", this.selected);
    },
  },
  methods: {
    handleInput(e) {
      console.log(e.context);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.search_inn = true;
        axios
          .get(
            "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party",
            {
              params: {
                token: "bf05fcc5d2c1055cceb60af0efbd46684c2755a1",
                branch_type: "MAIN",
                query: query,
              },
            }
          )
          .then((response) => {
            this.companyes_search = response.data.suggestions;
            this.search_inn = false;
          })
          .catch(() => {
            this.search_inn = false;
            this.$message({
              message: "Произошла ошибка, попробуйте еще раз позже!",
              type: "error",
            });
          });
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
